import React, {useState} from 'react'
import axios from "axios";
import {CSRF} from "../../../../constants";
import {capitalize, errorNotify} from "../../../../utils/app";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLanguage} from "@fortawesome/free-solid-svg-icons";
import Button from "../../Button";
import {deleteComments, updateComment} from "../../../../actions/pages";
import {useDispatch} from "react-redux";

const Translate = ({pageId, objectId, isMobile, inputRef, className = "square-btn", dm=false}) => {
    const dispatch = useDispatch()
    const [translated, setTranslated] = useState(false)
    const [origMessage, setOrigMessage] = useState("")

    // Replace entire input content for react-mentions (fallback when Tagify APIs not present)
    const replaceWholeInput = (text) => {
        if (!inputRef || !inputRef.current || typeof inputRef.current.focus !== 'function') return
        inputRef.current.focus()

        const el = document.activeElement
        if (!el) return

        // Try to replace via execCommand first (works well with IME/mentions)
        try {
            // Select all then insert
            if (el.select) el.select()
            document.execCommand('insertText', false, text)
            // Ensure React onChange fires if execCommand is ignored
            if (el.tagName === 'TEXTAREA') {
                // If value didn't change, set manually and dispatch input
                if (el.value !== text) {
                    el.value = text
                    el.dispatchEvent(new Event('input', { bubbles: true }))
                }
            }
            return
        } catch (_) {}

        // Hard fallback
        if (el.tagName === 'TEXTAREA') {
            el.value = text
            el.dispatchEvent(new Event('input', { bubbles: true }))
        }
    }

    // Get current message from Tagify or react-mentions shim
    const getCurrentMessage = () => {
        if (!inputRef || !inputRef.current) return ''
        // Tagify path
        if (inputRef.current.state && typeof inputRef.current.state.lastOriginalValueReported === 'string') {
            return inputRef.current.state.lastOriginalValueReported
        }
        // React-mentions shim path (we pass .value from parent)
        if (typeof inputRef.current.value === 'string') {
            return inputRef.current.value
        }
        return ''
    }

    // Set message using Tagify if available; otherwise react-mentions fallback
    const setMessage = (text) => {
        if (!inputRef || !inputRef.current) return

        // Tagify path
        if (typeof inputRef.current.removeAllTags === 'function' &&
            typeof inputRef.current.injectAtCaret === 'function') {
            inputRef.current.removeAllTags()
            inputRef.current.injectAtCaret(text)
            return
        }

        // React-mentions fallback
        replaceWholeInput(text)
    }

    const translate = (e) => {
        e.preventDefault()

        if(!translated) {
            const formData = new FormData()
            if(!dm) formData.append("page_id", pageId)

            const current = getCurrentMessage()
            if (inputRef) {
                formData.append("message", current)
            }

            axios({
                method: 'post',
                url: dm ? `/pages/${pageId}/direct_messages/${objectId}/translate` : `/comments/${objectId}/translate`,
                data: formData,
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': CSRF
                }
            }).then(response => {
                if (response.data.success) {
                    setTranslated(true)
                    setOrigMessage(response.data.original_message)

                    if (inputRef) {
                        setMessage(response.data.text)
                    } else {
                        if(dm){
                            // keep original behavior
                        } else {
                            // update the comment bubble fallback
                            dispatch(updateComment(objectId, {message: response.data.text}))
                        }
                    }
                } else {
                    errorNotify(response.data.text)
                }
            }).catch(error => {
                errorNotify(error?.response?.data?.error || 'Translation failed')
            })
        } else {
            // Toggle back to original
            setTranslated(false)
            if (inputRef) {
                setMessage(origMessage)
            } else {
                !dm && dispatch(updateComment(objectId, {message: origMessage}))
            }
        }
    }

    return (
        <button type="button" className={`${className} ${translated ? 'active' : ''}`} onClick={translate} data-tip={isMobile ? '' : "Translate"}
                aria-expanded="false">
            <FontAwesomeIcon icon={faLanguage} className="fa-fw"/>
        </button>
    )
}

export default React.memo(Translate)
